import React, { useState } from "react";
import Authenticated from "../components/header/Authenticated";
import MenuComponent from "../components/MenuComponent";
import { Affix, Layout } from "antd";
import Sider from "antd/es/layout/Sider";
import ContentRoute from "../routes/ContentRoute";
import { Header } from "antd/es/layout/layout";
import "../styles/header.css";
import logoNavy from "../assets/transparent-logo-navy.png";
import JobQueuePanel from "../components/generic/JobQueuePanel";
import ProjectSwitcher from "../components/generic/ProjectSwitcher";
import { useProject } from "../context/ProjectContext";

const { Content } = Layout;

function HomePage({ onLogout }) {
  const [collapsed, setCollapsed] = useState(false);
  const { activeProjectId } = useProject();

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        className="app-sidebar"
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        onBreakpoint={(broken) => {
          if (broken) setCollapsed(true);
        }}
        style={{
          background: "var(--arc-primary)",
          height: "100vh",
          position: "sticky",
          top: 0,
          overflow: "hidden",
        }}
        breakpoint="lg"
        width={220}
        collapsedWidth={80}
      >
        <div
          className={`sidebar-logo-wrap${collapsed ? " sidebar-logo-wrap--collapsed" : ""}`}
        >
          <div className="sidebar-logo-img-wrap">
            <img src={logoNavy} alt="ARC" className="sidebar-logo" />
          </div>
          {!collapsed && (
            <div className="sidebar-logo-text-wrap">
              <span className="sidebar-brand">ARC</span>
            </div>
          )}
        </div>

        <ProjectSwitcher collapsed={collapsed} />

        <MenuComponent />
      </Sider>

      <Layout style={{ width: "inherit", overflow: "hidden" }}>
        <Affix>
          <Header
            className="auth-header"
            style={{
              padding: 0,
              height: 60,
              minHeight: 60,
              maxHeight: 60,
              zIndex: 10,
              position: "relative",
            }}
          >
            <Authenticated onLogout={onLogout} />
          </Header>
        </Affix>
        <Content
          style={{
            padding: "16px",
            overflowY: "auto",
            height: "calc(100vh - 60px)",
            position: "relative",
            width: "100%",
          }}
        >
          {/* Keyed by project: switching remounts the current page so it
              refetches under the new X-Project-Id, with no per-page wiring. */}
          <ContentRoute key={activeProjectId} />
          {/* <JobQueuePanel /> */}
        </Content>
      </Layout>
    </Layout>
  );
}

export default HomePage;
